import styled from 'styled-components';
import { Link } from 'react-router-dom';
import theme from '../../../styles/defaultTheme';

export const AlertContainer = styled.div`
    width: 100%;

    & > button {
        width: 100%;
        max-width: 176px;
        float: right;
    }
`;

export const ContainerCard = styled.div`
    padding: 70px 16px 0;
    background-color: transparent;
`;

export const ContractNumber = styled.div`
    letter-spacing: 0px;
    color: ${(props) => props.theme.blackLink};
    font-size: ${theme.font.size16};
    font-weight: bold;
`;

export const ContractName = styled.div`
    min-height:44px;
    color: ${(props) => props.theme.greyLink};
    font-size: ${theme.font.size14};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;

export const ContractsQuantity = styled.div`
    margin-top: 10px;
    color: ${(props) => props.theme.greyLink};
    font-size: ${theme.font.size16};
`;

export const StyledLink = styled(Link)`
    width: 100%;    
    padding: 25px 32px;
`;

export const Right = styled.div`
    text-align: end;
    margin-top: -85px;
    margin-right: -15px;
`;

export const InfosContainer = styled.div`
    margin-right: 20px;
    width: 70%;
`;
